// =========================================================
// OLD STORAGE KEY
// Sirf purana stored data cleanup karne ke liye
// New preference history sessionStorage me save NAHI hogi
// =========================================================

const LEGACY_STORAGE_KEY = "chaafo_customization_history_v1";

// =========================================================
// READ HISTORY
// Ab old session preference kabhi restore nahi hogi
// =========================================================

export const readCustomizationHistory = () => {
  if (typeof window !== "undefined") {
    try {
      // Purana stored preference bhi permanently remove
      window.sessionStorage.removeItem(LEGACY_STORAGE_KEY);
    } catch (error) {
      console.error("Unable to clear old customization history:", error);
    }
  }

  return {};
};

// =========================================================
// CREATE UNIQUE KEY
// RESTAURANT + ITEM + SIZE
// =========================================================

export const buildCustomizationHistoryKey = (restaurantId, item) => {
  const cleanRestaurantId = String(
    restaurantId ||
      item?.restaurantId ||
      item?.restaurant_id ||
      item?.userid ||
      item?.userId ||
      "",
  ).trim();

  const itemId = String(
    item?.item_id || item?.itemId || item?.productId || "",
  ).trim();

  /*
   * IMPORTANT:
   * Menu item aur cart item dono me SAME size value use honi chahiye.
   *
   * Menu selected variant:
   * selected_size = "Half"
   *
   * Cart:
   * size = "Half"
   *
   * Isliye name first use kar rahe hain.
   */
  const size = String(
    item?.selected_size ||
      item?.size ||
      item?.sizeWords ||
      item?.sizeId ||
      item?.selected_size_id ||
      item?.size_id ||
      "regular",
  )
    .trim()
    .toLowerCase();

  return `${cleanRestaurantId}::${itemId}::${size}`;
};

// =========================================================
// NORMALIZE PREFERENCE
// =========================================================

const normalizePreference = (preference = {}) => {
  return Object.keys(preference)
    .sort()
    .reduce((result, key) => {
      const value = preference[key];

      if (
        value !== null &&
        value !== undefined &&
        String(value).trim() !== ""
      ) {
        result[key] = value;
      }

      return result;
    }, {});
};

// =========================================================
// APPEND PREFERENCE
// MEMORY ONLY
// SessionStorage me kuch save nahi hoga
// =========================================================

export const appendCustomizationPreference = (
  currentHistory,
  historyKey,
  preference,
) => {
  const cleanPreference = normalizePreference({
    ...(preference || {}),
  });

  if (Object.keys(cleanPreference).length === 0) {
    return currentHistory || {};
  }

  const existingPreferences = Array.isArray(currentHistory?.[historyKey])
    ? currentHistory[historyKey]
    : [];

  const newSignature = JSON.stringify(cleanPreference);

  const alreadyExists = existingPreferences.some(
    (savedPreference) =>
      JSON.stringify(normalizePreference(savedPreference)) === newSignature,
  );

  if (alreadyExists) {
    return currentHistory || {};
  }

  return {
    ...(currentHistory || {}),

    [historyKey]: [...existingPreferences, cleanPreference],
  };
};

// =========================================================
// CLEAR
// =========================================================

export const clearCustomizationHistory = () => {
  if (typeof window !== "undefined") {
    try {
      window.sessionStorage.removeItem(LEGACY_STORAGE_KEY);
    } catch (error) {
      console.error("Unable to clear customization history:", error);
    }
  }

  return {};
};

// =========================================================
// BUILD HISTORY FROM CURRENT CART ONLY
//
// IMPORTANT:
// Current cart me preference hai → show
// Cart se item remove → preference remove
// Clear cart → all preferences remove
// Refresh → cart ke existing customization se rebuild
// =========================================================

export const syncCustomizationHistoryWithCart = (cartItems = []) => {
  if (!Array.isArray(cartItems) || cartItems.length === 0) {
    return {};
  }

  const nextHistory = {};

  cartItems.forEach((cartItem) => {
    if (Number(cartItem?.quantity || 0) <= 0) {
      return;
    }

    const restaurantId = String(
      cartItem?.restaurantId || cartItem?.restaurant_id || "",
    ).trim();

    const itemId = String(
      cartItem?.itemId || cartItem?.item_id || cartItem?.productId || "",
    ).trim();

    if (!restaurantId || !itemId) {
      return;
    }

    // =====================================================
    // GET CUSTOMIZATION FROM CURRENT CART ITEM
    // =====================================================

    let preference = cartItem?.selectedCustomizations || {};

    // Fallback: customization JSON string
    if (
      !preference ||
      typeof preference !== "object" ||
      Array.isArray(preference) ||
      Object.keys(preference).length === 0
    ) {
      try {
        preference =
          typeof cartItem?.customization === "string"
            ? JSON.parse(cartItem.customization || "{}")
            : cartItem?.customization || {};
      } catch {
        preference = {};
      }
    }

    if (
      !preference ||
      typeof preference !== "object" ||
      Array.isArray(preference)
    ) {
      return;
    }

    const cleanPreference = normalizePreference(preference);

    if (Object.keys(cleanPreference).length === 0) {
      return;
    }

    // =====================================================
    // BUILD SAME ITEM/SIZE KEY
    // =====================================================

    const historyKey = buildCustomizationHistoryKey(restaurantId, cartItem);

    const currentPreferences = Array.isArray(nextHistory[historyKey])
      ? nextHistory[historyKey]
      : [];

    const newSignature = JSON.stringify(cleanPreference);

    const alreadyExists = currentPreferences.some(
      (savedPreference) =>
        JSON.stringify(normalizePreference(savedPreference)) === newSignature,
    );

    if (!alreadyExists) {
      nextHistory[historyKey] = [...currentPreferences, cleanPreference];
    }
  });

  return nextHistory;
};
